import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCroppedEvent, ImageCropperComponent, LoadedImage } from 'ngx-image-cropper';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { IdentityService } from 'src/app/api/services';

@Component({
  selector: 'app-modal-image-picker',
  templateUrl: './modal-image-picker.component.html',
  styleUrls: ['./modal-image-picker.component.scss'],
})
export class ModalImagePickerComponent {
  imageChangedEvent: any = '';
  croppedImage: any = '';
  imageBlob?: Blob;
  imageBase64?: string;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private sanitizer: DomSanitizer,
    private idService: IdentityService
  ) {}

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl!);
    this.imageBlob = event.blob!;
    const reader = new FileReader();
    reader.readAsDataURL(this.imageBlob);
    reader.onloadend = () => {
      this.imageBase64 = reader.result as string;
    };
    // event.blob can be used to upload the cropped image
  }
  imageLoaded(image: LoadedImage) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }
  close() {
    this.ref.close();
  }
  save() {
    this.ref.close({
      profile: this.imageBlob,
      profileBase64: this.imageBase64,
    });
  }
}
